/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { CircularProgress } from "@material-ui/core";
import Swal from "sweetalert2";

import NewTicketType from "./NewTicketType";

import { getRequest } from "utils/request";
import { putRequest } from "utils/request";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import { translate } from "../../../translate/i18n";
import exportExcel from "utils/exportExcel";
import formatDate from "utils/formatDate";

export default function TabTicketType({ companyData, handleUpdate }) {
  const [TicketType, setTicketType] = useState([]);
  const [loading, setLoading] = useState(true);
  const [onlyActive, setOnlyActive] = useState(true);
  const [globalFilter, setGlobalFilter] = useState("");
  const [newTicketType, setNewTicketType] = useState(false);
  const [selectedTicketType, setSelectedTicketType] = useState({});

  useEffect(() => {
    setGlobalFilter("");
    setLoading(true);
    getRequest(
      `/companiesticketstypes?CompanyId=${companyData.id}&onlyActive=${
        onlyActive ? 1 : 0
      }`
    ).then(function (response) {
      response.data.forEach((e) => {
        if (e.active === 1) {
          e.active = translate("userActive");
        } else {
          e.active = translate("inactive");
        }
      });
      setTicketType(response.data);
      setLoading(false);
    });
  }, [onlyActive]);

  const handleGoBack = () => {
    setNewTicketType(!newTicketType);
  };

  const handleNewTicketType = () => {
    handleUpdate(12);
    setNewTicketType(!newTicketType);
  };

  const handleEditTicketType = (data) => {
    setSelectedTicketType(data);
    setNewTicketType(!newTicketType);
  };

  const handleNew = () => {
    setSelectedTicketType({});
    setNewTicketType(true);
  };

  const handleinactivate = (id) => {
    Swal.fire({
      title: translate("attemption"),
      text: translate("deleteTicket"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: translate("confirmEraseCompany"),
    }).then((result) => {
      if (result.isConfirmed) {
        putRequest(`/companiesticketstypes/inactivate/${id}`).then(function (
          response
        ) {
          handleUpdate(12);
        });
      }
    });
  };

  const actionButtonsTemplate = (data) => {
    return (
      <div style={{ display: "flex", flexDirection: "row" }}>
        <div
          className="action-icon"
          style={{ cursor: "pointer", marginRight: 10 }}
          onClick={() => handleEditTicketType(data)}
        >
          <i className="mdi mdi-pencil" style={{ fontSize: 20 }}></i>
        </div>
        {!data.default && (
          <div
            className="action-icon"
            style={{ cursor: "pointer" }}
            onClick={() => handleinactivate(data.id)}
          >
            <i className="mdi mdi-delete" style={{ fontSize: 20 }}></i>
          </div>
        )}
      </div>
    );
  };

  const header = (
    <div className="data-table-header">
      <div
        className="checkbox-container"
        style={{ position: "absolute", left: 0 }}
      >
        <input
          checked={onlyActive}
          onChange={() => setOnlyActive(!onlyActive)}
          type="checkbox"
          className="checkbox"
          style={{ marginRight: 10 }}
        />
        <label>{translate("showInactive")}</label>
      </div>
      <i className="pi pi-search" style={{ paddingRight: 10 }}></i>
      <input
        className="input-globalfilter"
        type="search"
        onChange={(e) => setGlobalFilter(e.target.value)}
        placeholder="Buscar"
        icon="pi pi-search"
      />
    </div>
  );

  const ticketTypeTemplate = (data) => {
    return <span>{data.default ? "Sim" : "Não"}</span>;
  };

  const handleExport = () => {
    let data = [];

    TicketType.forEach((e) => {
      const ticketAux = {
        Id: e.id,
        [translate("description")]: e.description,
        [translate("defaultTicketType")]:
          e.default === 1 ? translate("yes") : translate("no"),
        [translate("createdAt")]: formatDate(e.createdAt),
      };

      data.push(ticketAux);
    });
    exportExcel(data, translate("ticketType"));
  };

  return (
    <div className="list-container">
      {!newTicketType ? (
        <>
          <div className="tab-content">
            <div className="tab-pane show active" id="multi-item-preview">
              <div
                className="title-helper-container"
                style={{ borderWidth: !newTicketType && 0 }}
              >
                <h3>{companyData.nickName}</h3>
                <button
                  style={{ marginBottom: 5 }}
                  type="button"
                  onClick={handleExport}
                  className="export-excel"
                >
                  <i
                    style={{ fontSize: 16, marginRight: 5 }}
                    className="pi pi-file-excel"
                  />
                  <span style={{ fontSize: "1vw" }}>
                    {translate("exportAllData")}
                  </span>
                </button>
              </div>
              {!loading ? (
                <DataTable
                  header={header}
                  globalFilter={globalFilter}
                  dataKey="id"
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  value={TicketType}
                  paginator
                  rows={5}
                  emptyMessage={translate("noTicketFinded")}
                >
                  <Column
                    field="description"
                    header={translate("description")}
                    sortable
                  ></Column>
                  <Column
                    body={ticketTypeTemplate}
                    header={translate("defaultTicketType")}
                  ></Column>
                  <Column header={translate("status")} field="active"></Column>
                  <Column
                    body={actionButtonsTemplate}
                    field="action"
                    header={translate("action")}
                  ></Column>
                </DataTable>
              ) : (
                <div className="area-loading">
                  <CircularProgress />
                </div>
              )}
            </div>
          </div>
          <div className="button-add-relative" onClick={() => handleNew()}>
            <i className="mdi mdi-plus"></i>
          </div>
        </>
      ) : (
        <NewTicketType
          handleNewTicketType={handleNewTicketType}
          selectedTicketType={selectedTicketType}
          handleGoBack={handleGoBack}
          companyData={companyData}
        />
      )}
    </div>
  );
}
